export const GET_MINI_PROGRAM_GOV = 'MINI_PROGRAM_GOV/get_mini_program_gov';
export const GET_SINGLE_MINI_PROGRAM_GOV = 'MINI_PROGRAM_GOV/GET_SINGLE_mini_program_gov';
export const UPDATE_MINI_PROGRAM_GOV = 'MINI_PROGRAM_GOV/update_mini_program_gov';
export const CREATE_MINI_PROGRAM_GOV = 'MINI_PROGRAM_GOV/create_mini_program_gov';
export const REMOVE_MINI_PROGRAM_GOV = 'MINI_PROGRAM_GOV/remove_mini_program_gov';

export const FORM_DATA = {
  name: '',
  description: '',
  icon_url: '',
  redirect_url: '',
  type: '',
  sequence: '',
  is_active: '',
};

export const GOV_TYPE_LIST = [
  // {label: 'ALL TYPES', value: ''},
  {label: 'NATIONAL', value: 'NATIONAL'},
  {label: 'LGU', value:'LGU'},
]
